// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a324e796","239":"00d562a3","455":"ccf9a54f"}[chunkId] + ".chunk.js";
};